import React, { useEffect, useState, useRef } from "react";
import { observer } from "mobx-react-lite";
import "./AdminUsuarios_style.css";
import { useStore } from "../../../app/stores/store";
import Accordion from "react-bootstrap/Accordion";
import Table from "react-bootstrap/Table";
import { Button, Icon } from "semantic-ui-react";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import ModalEliminarInscripcion from "../../../features/SGPersonas/form/ModalEliminarInscripcion";
import ModalEliminarMovimiento from "../../../features/SGPersonas/form/ModalEliminarMovimiento";
import ModalCrearMovimiento from "../../../features/SGPersonas/form/ModalCrearMovimiento";
import ModalEditarMovimiento from "../../../features/SGPersonas/form/ModalEditarMovimiento";
import { log } from "console";
import inscriptionsStore from "../../../app/stores/InscriptionsStore";
import { MovimientoFormValues } from "../../../app/models/CCTMovimientoCreate";

import { cuentasCursosList } from "../../../app/models/UsersList";


interface Props {
  idUsuario: string;
}

export default observer(function FichaCursos(props: Props) {
  const { UsersListStore, modalStore, CCTiposDeTransaccionStore } = useStore();
  const { CursosUsuarioByCodigo } = UsersListStore;
  const {getCCTipoDeTransaccion} = CCTiposDeTransaccionStore;

  const [updateCounter, setUpdateCounter] = useState(0);

  useEffect(() => {
    UsersListStore.ListaCursosUsuario(props.idUsuario);
    CCTiposDeTransaccionStore.loadCCTiposDeTransacciones();
  }, [UsersListStore, CCTiposDeTransaccionStore, props.idUsuario]);

  function handleClickDeleteInscription(
    idInscripcion: number,
    userId: string,
    catEdicionesId: number,
    codigoInstitucional: string
  ) {
    modalStore.openModal(
      <ModalEliminarInscripcion
        id={idInscripcion}
        appUserId={userId}
        catEdicionesId={catEdicionesId}
        codigoInstitucional={codigoInstitucional}
        updateCourseList={updateCourseList}
      />,
      "mini"
    );
  }

  function handleClickDeleteMovimiento(
    userId: string,
    cuenta: string,
    codigoTipoTransaccion: number,
    numeroTransaccion: string
  ) {
    modalStore.openModal(
      <ModalEliminarMovimiento
        userId={userId}
        cuenta={cuenta}
        codigoTipoTransaccion={codigoTipoTransaccion}
        numeroTransaccion={numeroTransaccion}
        updateCourseList={updateCourseList}
      />,
      "mini"
    );
  }

  function handleClickCreate(cuenta: string, catEdicionesId: number){
    modalStore.openModal(<ModalCrearMovimiento 
        userId= {props.idUsuario} 
        cuenta={cuenta} 
        catEdicionesId={catEdicionesId} 
        updateCourseList={updateCourseList}
        />,
         "mini");
  }

  function handleClickEdit(cuenta: string, catEdicionesId: number, movimiento: MovimientoFormValues){
    modalStore.openModal(<ModalEditarMovimiento 
        userId= {props.idUsuario} 
        cuenta={cuenta} 
        catEdicionesId={catEdicionesId}
        movimiento={movimiento}
        updateCourseList={updateCourseList}
        />,
         "mini");
  }

  const updateCourseList = () => {
    setUpdateCounter(updateCounter + 1);
    UsersListStore.ListaCursosUsuario(props.idUsuario);
  };

  function getColorBorder (indice: number) : string{ //funcion para variar el color de las fichas de los cursos
    if((indice + 3) % 3 == 0){
      return "accordion_curso curso_verde"
    }else if((indice + 2) % 3 == 0){
      return "accordion_curso curso_amarillo";
    }
    return "accordion_curso curso_azul";
  }

  function IconoTooltip({children, content}) { //funcion para mostrar tooltip de reversion
    return (
      <OverlayTrigger
        placement="top"
        delay={{ show: 50, hide: 200 }}
        overlay={<Tooltip id="tooltip-top">
                  Justificación proveída: {content}
                </Tooltip>
      }>
        <div>{children}</div>
      </OverlayTrigger>
    );
  }

  return (
    <>
      <Accordion key={updateCounter}>

        {CursosUsuarioByCodigo.map((curso: cuentasCursosList, indice: number) => {
          const fechaInFormato = new Date(curso.inscripcion.fechaCreacion);
          const diaInscripcion = fechaInFormato
            .getDate()
            .toString()
            .padStart(2, "0");
          const mesInscripcion = (fechaInFormato.getMonth() + 1)
            .toString()
            .padStart(2, "0");
          const anioInscripcion = fechaInFormato.getFullYear().toString();
          const fechaInFormateada = `${diaInscripcion}/${mesInscripcion}/${anioInscripcion}`;

          const fechaAperturaFormato = new Date(curso.account.fechaApertura);
          const diaApertura = fechaAperturaFormato
            .getDate()
            .toString()
            .padStart(2, "0");
          const mesApertura = (fechaAperturaFormato.getMonth() + 1)
            .toString()
            .padStart(2, "0");
          const anioApertura = fechaAperturaFormato.getFullYear().toString();
          const fechaApFormateada = `${diaApertura}/${mesApertura}/${anioApertura}`;
          
          return (
            <Accordion.Item
              className={getColorBorder(indice)}//llamando a funcion para obtener color de la ficha
              eventKey={curso.courseName}
            >
              <Accordion.Header className="nombre_curso_accordion">
                {curso.courseName}
              </Accordion.Header>
              <Accordion.Body style={{ width: "100%" }}>
                <hr className="hr_body_accordion_cuenta"></hr>
                <div className="contenedor_tabla_cuenta">
                  <Table responsive striped>
                    <thead>
                      <tr>
                        <th>Fecha de Inscripción</th>
                        <th>Código Institucional</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{fechaInFormateada}</td>
                        <td style={{ textAlign: "center" }}>
                          {curso.inscripcion.codigoInstitucional
                            ? curso.inscripcion.codigoInstitucional
                            : "No aplica"}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
                <div
                  className="contenedor_tabla_cuenta "
                  style={{ marginTop: "15px" }}
                >
                  <Table responsive striped>
                    <thead>
                      <tr>
                        <th>Cuenta</th>
                        <th>T. de cuenta</th>
                        <th>F. apertura</th>
                        <th>Saldo inicial</th>
                        <th>Saldo actual</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{curso.account.cuenta}</td>
                        <td style={{ textAlign: "center" }}>
                          {curso.account.codigoTipoCuenta}
                        </td>
                        <td>{fechaApFormateada}</td>
                        <td style={{ textAlign: "right" }}>
                          Q{curso.account.saldoInicial}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          Q{curso.account.saldoActual}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
                <div
                  className="contenedor_tabla_cuenta"
                  style={{ marginTop: "15px" }}
                >
                <Table responsive striped>
                    <thead>
                        <div style={{margin: "10px", textAlign: "left"}}>
                            <Button
                                animated = "vertical"
                                style ={{width:"100px", margin:"0px"}}
                                circular
                                color= "blue"
                                size="medium"
                                onClick={() =>
                                    
                                    handleClickCreate(curso.account.cuenta, 
                                      curso.inscripcion.catEdicionesId)
                                }
                            >
                                <Button.Content hidden><Icon name="add"/></Button.Content>
                                <Button.Content visible>Agregar</Button.Content>
                            </Button>
                        </div>
                            
                        <tr style={{verticalAlign: "middle"}}>
                            <th style={{verticalAlign: "middle"}}>Tipo de Transacción</th>
                            <th style={{width: "15%", verticalAlign: "middle"}}>Transacción No.</th>
                            <th style={{verticalAlign: "middle"}}>Fecha</th>
                            <th style={{width: "15%", verticalAlign: "middle"}}>Doc. Contable</th>
                            <th style={{verticalAlign: "middle"}}>Valor</th>
                            <th style={{verticalAlign: "middle"}}>Acción</th>
                        </tr>
                    </thead>
                    <tbody>
                      {curso.account.movimientos.map((movimiento) => {
                        const fechaAperturaFormato = new Date(movimiento.fecha);
                        const dia = fechaAperturaFormato
                          .getDate()
                          .toString()
                          .padStart(2, "0");
                        const mes = (fechaAperturaFormato.getMonth() + 1)
                          .toString()
                          .padStart(2, "0");
                        const anio = fechaAperturaFormato
                          .getFullYear()
                          .toString();
                        const fechaFormateada = `${dia}/${mes}/${anio}`;
                        return (
                          <tr>
                            {getCCTipoDeTransaccion(movimiento.codigoTipoTransaccion)?.descripcion == "REVERSION" ?
                            //condicion para mostrar o no el icono tooltip de reversion
                              <td className="contenedor_reversion">
                                <div className="contenedor_contenedor">
                                  <div>{getCCTipoDeTransaccion(movimiento.codigoTipoTransaccion)?.descripcion}</div>
                                  <IconoTooltip content={movimiento.justificacion}>
                                    <div className="icon_tooltip"><Icon name="info"/></div>
                                  </IconoTooltip>
                                </div>
                              </td>

                            : <td style={{verticalAlign: "middle"}}>{getCCTipoDeTransaccion(movimiento.codigoTipoTransaccion)?.descripcion}</td>}

                            <td style={{verticalAlign: "middle"}}>{movimiento.numeroTransaccion}</td>
                            <td style={{verticalAlign: "middle"}}>{fechaFormateada}</td>
                            <td style={{verticalAlign: "middle"}}>{[2, 3, 4, 8, 10, 13].includes(movimiento.codigoTipoTransaccion) ? movimiento.numeroDeDocumentoContable : "No aplica"}</td>
                            <td style={{ textAlign: "right", verticalAlign: "middle" }}>
                              Q{movimiento.valor}
                            </td>
                            <td className="contenedor_acciones_cursos">
                              {movimiento.codigoTipoTransaccion != 1 && (
                                <Button
                                  style ={{width:"35px", margin:"3px"}}
                                  circular
                                  color="blue"
                                  icon = "pencil"
                                  size="mini"
                                  onClick={() => {
                                    handleClickEdit(curso.account.cuenta, 
                                      curso.inscripcion.catEdicionesId,
                                      movimiento)
                                  }}
                                />
                              )}
                            <Button
                                style ={{width:"35px", margin:"3px"}}
                                circular
                                color="red"
                                icon = "ban"
                                size="mini"
                                onClick={() =>
                                    handleClickDeleteMovimiento(
                                        props.idUsuario,
                                        movimiento.cuenta,
                                        movimiento.codigoTipoTransaccion,
                                        movimiento.numeroTransaccion
                                        )
                                }
                            />
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                        
                </Table>
                </div>
                <div style={{ marginTop: "15px", display: "flex" }}>
                  <div style={{ width: "130px", height: "40px" }}>
                    <Button
                        animated = "vertical"
                        circular
                        color="red"
                        size="medium"
                        onClick={() =>
                            handleClickDeleteInscription(
                            curso.inscripcion.id,
                            props.idUsuario,
                            curso.inscripcion.catEdicionesId,
                            curso.inscripcion.codigoInstitucional
                            )
                        }
                    >
                        <Button.Content hidden><Icon name="ban"/></Button.Content>
                        <Button.Content visible>Desmatricular</Button.Content>
                    </Button>
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          );
        })}
      </Accordion>
    </>
  );
});
